import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import { EditCategoryContext, IEditCategoryContext } from '../../../editCategoryState/editCategoryContext';
import React, { useContext, useMemo } from 'react';
import { InputFields } from './components/InputFields';
import style from './EditForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '13:8',
		optimalResolutions: {
			a: '208*128px',
			b: '416*256px',
		},
	},
	vertical: {
		ratio: '13:8',
		optimalResolutions: {
			a: '208*128px',
			b: '416*256px',
		},
	},
};

export const EditForm: React.FC = () => {
	const { setFileId, deletePhoto, fileId, filePath, categoryID } =
		useContext<IEditCategoryContext>(EditCategoryContext);

	const loadFromFilePathOptions = useMemo(
		() => ({
			filePath,
			preSignedUrl: null,
			entityID: categoryID,
		}),
		[filePath, categoryID],
	);

	return (
		<div className={style.container} data-test="EditForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				loadFromFilePathOptions={loadFromFilePathOptions}
				deletePhotoHandler={deletePhoto}
				setFileId={setFileId}
				horizontalAspectRatio={208 / 128}
				verticalAspectRatio={208 / 128}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};
